import { useEffect } from "react";
import { ScrollTracker } from "./ScrollTracker";

export const Scroll = () => {
  useEffect(() => {
    let rootName = "";

    if (window.location.href === "https://www.michalkrol.com/#/") {
      rootName = "home";
    } else if (window.location.href.includes("cycles")) {
      rootName = "cycles";
    } else if (window.location.href.includes("artworks")) {
      rootName = "artworks";
    } else if (window.location.href.includes("exhibitions")) {
      rootName = "exhibitions";
    } else if (window.location.href.includes("reports")) {
      rootName = "reports";
    } else if (window.location.href.includes("biography")) {
      rootName = "biography";
    } else if (window.location.href.includes("contact")) {
      rootName = "contact";
    } else {
      rootName = "other";
    }

    sessionStorage.setItem("page_from", sessionStorage.getItem("page_to"));
    sessionStorage.setItem("page_to", rootName);

    const from = sessionStorage.getItem("page_from");
    const to = sessionStorage.getItem("page_to");

    const pos = parseInt(sessionStorage.getItem("scroll_tracker") || "0", 10);

    const scrollWhenReady = () => {
      const maxScroll = document.documentElement.scrollHeight;
      if (maxScroll > pos) {
        window.scrollTo({
          top: pos,
          left: 0,
          behavior: "smooth",
        });
      } else {
        setTimeout(scrollWhenReady, 100);
      }
    };

    if (
      (from === "reports" && to === "exhibitions") ||
      (from === "artworks" && to === "cycles")
    ) {
      scrollWhenReady();
    } else {
      window.scrollTo(0, 0);
      const timer = setTimeout(() => {
        window.scrollTo({
          top: window.innerHeight,
          left: 0,
          behavior: "smooth",
        });
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  return null;
};
